import { render, staticRenderFns } from "./create-sales-order-dialog.vue?vue&type=template&id=5fa5a5a7&scoped=true&"
import script from "./create-sales-order-dialog.vue?vue&type=script&lang=js&"
export * from "./create-sales-order-dialog.vue?vue&type=script&lang=js&"
import style0 from "./create-sales-order-dialog.vue?vue&type=style&index=0&id=5fa5a5a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa5a5a7",
  null
  
)

export default component.exports